export default __webpack_public_path__ + "static/media/aput.bdedbc85.png";